import { render, staticRenderFns } from "./course-drawer-factory.vue?vue&type=template&id=5179f5e8&scoped=true"
import script from "./course-drawer-factory.vue?vue&type=script&lang=js"
export * from "./course-drawer-factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5179f5e8",
  null
  
)

export default component.exports